<template>
  <div class="message-list-page">
    <NavBar title="管理页" fixed left-arrow @click-left="handleBack" />

    <div class="list-wrapper">
      <List
          v-model:loading="loading"
          :finished="finished"
          finished-text="已加载全部"
          @load="loadMore"
      >
        <Empty v-if="messageList.length === 0 && !loading" description="暂无数据" />

        <div v-else class="list-body">
          <SwipeCell
              v-for="item in messageList"
              :key="item.id"
              :right-width="60"
              class="swipe-cell"
          >
            <div class="item-card" @click="handleItemClick(item)">
              <div class="content">
                <div class="row">
                  <span class="label">社交软件：</span>
                  <span class="val">{{ item.channelName }}</span>
                </div>
                <div class="row">
                  <span class="label">联系方式：</span>
                  <span class="val">{{ item.accountInfo }}</span>
                </div>
                <div class="row">
                  <span class="label">传话时间：</span>
                  <span class="val">{{ formatTime(item.sendTime) }}</span>
                </div>
                <div class="row">
                  <span class="label">传话状态：</span>
                  <span class="val red">{{ getMsgStatus(item.msgStatus) }}</span>
                </div>
              </div>

              <!-- 改用 Icon 组件 -->
              <Icon name="arrow" class="arrow" />
            </div>

            <template #right>
              <div class="del-btn" @click.stop="handleDelete(item.id)">删除</div>
            </template>
          </SwipeCell>
        </div>
      </List>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { NavBar, List, Empty, SwipeCell, Icon, Toast } from 'vant'
import {getMessengerList} from '@/api/messenger'
const messageList = ref([])
const loading = ref(false)
const finished = ref(false)

// 加载数据（带唯一ID）
const loadMore = () => {
  loading.value = true
  getMessengerList().then(res => {
    // 后端数据 => 前端下拉格式
    messageList.value = res.data.data.map(item => ({
      ...item,
    }));
    loading.value = false
    finished.value = true
  })

}

// 时间格式化：年月日 时分秒
const formatTime = (time) => {
  const d = new Date(time)
  const year = d.getFullYear()
  const month = String(d.getMonth() + 1).padStart(2, '0')
  const day = String(d.getDate()).padStart(2, '0')
  const hh = String(d.getHours()).padStart(2, '0')
  const mm = String(d.getMinutes()).padStart(2, '0')
  const ss = String(d.getSeconds()).padStart(2, '0')
  return `${year}-${month}-${day} ${hh}:${mm}:${ss}`
}

const getMsgStatus = (type) => {
  if (type === 0) {
    return "已发送"
  }else if (type === 1) {
    return '未发送'
  }else if (type === 2) {
    return '发送失败'
  }else if (type === 3) {
    return '已取消'
  }else if (type === 4) {
    return '审核中'
  }else if (type === 5) {
    return '审核不过'
  }else  {

    return '已发送'
  }
}

const handleItemClick = () => Toast('查看')
const handleBack = () => history.back()

// 根据ID删除（彻底解决不归位）
const handleDelete = (id) => {
  messageList.value = messageList.value.filter(item => item.id !== id)
  Toast('删除成功')
}

onMounted(() => loadMore())
</script>

<style scoped>
.message-list-page {
  height: 100vh;
  background: #f5f5f5;
}
.list-wrapper {
  padding-top: 46px;
}
.list-body {
  width: 100%;
}

:deep(.swipe-cell) {
  margin-bottom: 8px;
  background: #fff;
  border-radius: 0;
  overflow: hidden;
}
:deep(.van-swipe-cell__right) {
  width: 60px !important;
  background: #ff4749;
}

.item-card {
  background: #fff;
  padding: 12px 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.content {
  flex: 1;
}
.row {
  font-size: 15px;
  line-height: 1.6;
}
.label {
  color: #666;
  min-width: 80px;
  display: inline-block;
}
.val {
  color: #333;
}
.red {
  color: #ff4749;
}
.arrow {
  color: #ccc;
  font-size: 16px;
}

.del-btn {
  width: 60px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 14px;
  background: #ff4749;
}
</style>